import moment from 'moment';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var MaintenanceFilterState = /** @class */ (function () {
    function MaintenanceFilterState() {
        this.onChangeFilter = new Subject();
        this.onClearFilter = new Subject();
        this.defaultQuery = {
            openedAt_lte: moment().endOf('day').toISOString(),
            openedAt_gte: moment().subtract(1, 'years').startOf('day').toISOString(),
            archived: false,
        };
        this.query = this.defaultQuery;
    }
    MaintenanceFilterState.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaintenanceFilterState_Factory() { return new MaintenanceFilterState(); }, token: MaintenanceFilterState, providedIn: "root" });
    return MaintenanceFilterState;
}());
export { MaintenanceFilterState };
